module.exports = __webpack_public_path__ + "static/media/store.ab70730c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/store.png
// module id = 48
// module chunks = 0